import moment from "moment";
import { Time } from "bp-common-models-lib";
import { ApicallService } from "@core-services/apicall.service";

export function currentDate(format: string = "YYYY_MM_DD__HH_mm_ss"): string {
	return moment(new Date()).format(format);
}

export function formatDate(date: moment.MomentInput, format: string = "DD.MM.YYYY, HH:mm"): string {
	return calibrateUTCOffset(date).format(format);
}

export function isBetween(start: Time, end: Time): boolean {
	return inPast(start) && inFuture(end);
}

export function inFuture(t: Time): boolean {
	return +calibrateUTCOffset(t.date()) > +calibrateUTCOffset(new Date(ApicallService.currentTimeStamp));
}

export function inPast(t: Time): boolean {
	return +calibrateUTCOffset(t.date()) < +calibrateUTCOffset(new Date(ApicallService.currentTimeStamp));
}

export function calibrateUTCOffset(date: moment.MomentInput): moment.Moment {
	const offset = (moment(ApicallService.currentTimeStamp).utcOffset() - moment(new Date()).utcOffset()) * 60;

	const calibratedUnix = moment(date).unix() - offset;
	return moment(calibratedUnix * 1000);
}

export function currentDateWithoutTime(format: string = "ll"): string {
	// Eg: Sep 4, 1986
	return currentDate(format);
}

export function daysFromNow(days: number): Date {
	return moment().add(days, "days").toDate();
}

export function getMonths(lang: string, format: "numeric" | "short" | "long" = "long"): string[] {
	const applyFormat = new Intl.DateTimeFormat(lang, { month: format }).format;
	return [...Array(12).keys()].map((m) => applyFormat(new Date(2021, m)));
}

export function getDateTimeDifference(startDateTimeString: string, endDateTime: Date = new Date()): number {
	const startDateTime = Date.parse(startDateTimeString);
	if (Number.isNaN(startDateTime)) {
		return;
	}
	const difference = endDateTime.getTime() - startDateTime;
	return difference / 1000 / 60;
}
